export default __webpack_public_path__ + "static/media/WF6.ea9cedcd.png";